// import React from "react";
// import { useState } from "react";
// import { Box, Card, IconButton, Typography, Skeleton } from "@mui/material";
// import ShareIcon from "@mui/icons-material/Share";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

// export default function PlotStatusCard({ imageUrl, approved, title, loading }) {

//   const [index, setIndex] = useState(0);
//   const safeImage = Array.isArray(imageUrl) ? imageUrl : []

//   const next = () => setIndex((i) => (i + 1) % imageUrl.length);
//   const prev = () => setIndex((i) => (i - 1 + imageUrl.length) % imageUrl.length);

//   const handleShare = () => {
//     const shareUrl = window.location.href;

//     if (navigator.share) {
//       navigator.share({
//         title: title || "Property",
//         text: "Check out this property",
//         url: shareUrl,
//       });
//     } else {
//       navigator.clipboard.writeText(shareUrl);
//       alert("Link copied to clipboard");
//     }
//   };



//   return (
//     <Card
//       elevation={4}
//       sx={{
//         width: "100%",
//         height: 375,
//         borderRadius: "18px",
//         // overflow: "hidden",
//         position: "relative",
//         border: "6px solid #ffffff",
//       }}
//     >


//       {/* IMAGE */}
//       {/* <Box
//         sx={{
//           width: "100%",
//           height: "100%",
//           backgroundImage: `url(${imageUrl})`,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//         }}
//       /> */}

//       <Box>
//         {/* IMAGE AREA */}
//         <Box
//           sx={{
//             width: "100%",
//             height: 280,
//             borderRadius: 4,
//             overflow: "hidden",
//             position: "relative",
//           }}
//         >
//           {loading ? <Skeleton
//             variant="rectangular"
//             animation="wave" // shimmer effect
//             width="100%"
//             height="100%" // adjust based on your image height
//             sx={{ borderRadius: 2 }}
//           /> :
//             <img
//               src={safeImage[index] || "/assets/images/placeholder_img.png"}
//               alt="preview"
//               style={{
//                 width: "100%",
//                 height: "100%",
//                 objectFit: "cover",
//               }}
//             />}

//           {/* Right arrow */}
//           {safeImage?.length > 1 && <IconButton
//             onClick={next}
//             sx={{
//               position: "absolute",
//               right: 8,
//               top: "50%",
//               transform: "translateY(-50%)",
//               background: "white",
//             }}
//           >
//             <ArrowForwardIosIcon fontSize="small" />
//           </IconButton>}

//           {/* Left arrow */}
//           {safeImage?.length > 1 && <IconButton
//             onClick={prev}
//             sx={{
//               position: "absolute",
//               left: 8,
//               top: "50%",
//               transform: "translateY(-50%)",
//               background: "white",
//             }}
//           >
//             <ArrowBackIosNewIcon fontSize="small" />
//           </IconButton>}

//           {/* Share Icon (top-right) */}
//           <IconButton
//             sx={{
//               position: "absolute",
//               top: 10,
//               right: 10,
//               background: "white",

//             }}
//             onClick={handleShare}
//           >
//             <ShareIcon fontSize="small" />
//           </IconButton>

//           {/* Pagination dots */}
//           {/* Pagination dots */}
//           {safeImage?.length > 1 && (
//             <Box
//               sx={{
//                 position: "absolute",
//                 bottom: 10,
//                 left: "50%",
//                 transform: "translateX(-50%)",
//                 display: "flex",
//                 gap: 1,
//                 zIndex: 2,
//               }}
//             >
//               {safeImage.map((_, i) => (
//                 <Box
//                   key={i}
//                   sx={{
//                     width: 8,
//                     height: 8,
//                     borderRadius: "50%",
//                     bgcolor: i === index ? "#fff" : "rgba(255,255,255,0.5)",
//                     cursor: "pointer",
//                   }}
//                   onClick={() => setIndex(i)}
//                 />
//               ))}
//             </Box>
//           )}



//         </Box>





//       </Box>

//       <Typography
//         sx={{
//           pt: { xs: 2, md: 2 },
//           pb: 1,
//           textAlign: "center",
//           fontWeight: 600,
//           fontSize: 17,
//           display: "-webkit-box",
//           WebkitLineClamp: 2,
//           WebkitBoxOrient: "vertical",
//           overflow: "hidden",
//           textOverflow: "ellipsis",
//         }}
//       >
//         {title || ""}
//       </Typography>


//       {/* <Typography>None</Typography> */}

//       {/* APPROVED RED RIBBON */}
//       {/* {approved && (
//         <Box
//           sx={{
//             position: "absolute",
//             top: 18,
//             left: -42,
//             background: "#d32f2f",
//             color: "white",
//             padding: "8px 50px",
//             fontSize: "15px",
//             fontWeight: 700,
//             transform: "rotate(-30deg)",
//             boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
//             display: "flex",
//             alignItems: "center",
//             gap: "6px",
//           }}
//         >
//           APPROVED
//         </Box>
//       )} */}

//       {/* SHARE ICON */}
//       {/* <IconButton
//         sx={{
//           position: "absolute",
//           top: 12,
//           right: 12,
//           background: "rgba(255,255,255,0.8)",
//           "&:hover": { background: "white" },
//         }}
//       >
//         <ShareIcon sx={{ fontSize: 22 }} />
//       </IconButton> */}
//     </Card>
//   );
// }


import React, { useState, useRef } from "react";
import { Box, Card, IconButton, Typography, Skeleton, Dialog, Fade, DialogContent } from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CloseIcon from "@mui/icons-material/Close";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import Slider from "react-slick";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import YouTubeIcon from "@mui/icons-material/YouTube";

export default function PlotStatusCard({ imageUrl, approved, title, loading, whatsappNumber, youtubeLink }) {
  const [index, setIndex] = useState(0);
  const [openPreview, setOpenPreview] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const videoRef = useRef(null);
  const previewVideoRefs = useRef({});
  const previewSliderRef = useRef();
  const [activeIndex, setActiveIndex] = useState(0);
  const handleImagePreview = (index) => {
    setActiveIndex(index);
    setOpenPreview(true);

    setTimeout(() => {
      previewSliderRef.current?.slickGoTo(index);
    }, 100);
  };
  const safeImage = Array.isArray(imageUrl) ? imageUrl : [];

  const isVideo = (url) => {
    if (typeof url !== 'string') return false;
    return /\.(mp4|webm|mkv|mov|avi)$/i.test(url);
  };

  const next = (e) => {
    e.stopPropagation();
    setIndex((i) => (i + 1) % safeImage.length);
  };

  const prev = (e) => {
    e.stopPropagation();
    setIndex((i) => (i - 1 + safeImage.length) % safeImage.length);
  };

  const togglePlay = (e) => {
    e.stopPropagation();
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const togglePreviewPlay = (e, img) => {
    e.stopPropagation();
    const v = previewVideoRefs.current[img];
    if (v) {
      if (!v.paused) {
        v.pause();
      } else {
        v.play();
      }
      // Force re-render to update icon
      setOpenPreview(prev => prev);
    }
  };

  const handleShare = (e) => {
    e.stopPropagation();
    const shareUrl = window.location.href;
    if (navigator.share) {
      navigator.share({
        title: title || "Property",
        text: "Check out this property",
        url: shareUrl,
      });
    } else {
      navigator.clipboard.writeText(shareUrl);
      alert("Link copied to clipboard");
    }
  };

  return (
    <>
      {/* CARD */}
      <Card
        elevation={4}
        sx={{
          width: "100%",
          borderRadius: "18px",
          position: "relative",
          border: "6px solid #ffffff",
          cursor: "pointer",
        }}
        onClick={() => setOpenPreview(true)}
      >
        {/* IMAGE */}
        <Box
          sx={{
            width: "100%",
            height: 280,
            borderRadius: 4,
            overflow: "hidden",
            position: "relative",
          }}
        >
          {loading ? (
            <Skeleton
              variant="rectangular"
              animation="wave"
              width="100%"
              height="100%"
              sx={{ borderRadius: 2 }}
            />
          ) : isVideo(safeImage[index]) ? (
            <Box
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              sx={{ position: "relative", width: "100%", height: "100%" }}
            >
              <Box
                component="video"
                ref={videoRef}
                src={safeImage[index]}
                muted
                loop
                playsInline
                disablePictureInPicture
                disableRemotePlayback
                controlsList="nopictureinpicture"
                onContextMenu={(e) => e.preventDefault()}
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
              {(isHovered || !isPlaying) && (
                <IconButton
                  onClick={togglePlay}
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    bgcolor: "rgba(0,0,0,0.5)",
                    color: "white",
                    borderRadius: "4px", // Rectangular
                    "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
                  }}
                >
                  {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
                </IconButton>
              )}
            </Box>
          ) : (
            <img
              src={safeImage[index] || "/assets/images/placeholder_img.png"}
              alt="preview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          )}

          {/* Navigation arrows */}
          {safeImage.length > 1 && (
            <>
              <IconButton
                onClick={prev}
                sx={{
                  position: "absolute",
                  left: 8,
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "rgba(255,255,255,0.8)",
                  "&:hover": { background: "white" },
                }}
              >
                <ArrowBackIosNewIcon />
              </IconButton>
              <IconButton
                onClick={next}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: "50%",
                  transform: "translateY(-50%)",
                  background: "rgba(255,255,255,0.8)",
                  "&:hover": { background: "white" },
                }}
              >
                <ArrowForwardIosIcon />
              </IconButton>
            </>
          )}

          {/* Share button */}
          <IconButton
            onClick={handleShare}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              background: "rgba(255,255,255,0.8)",
              "&:hover": { background: "white" },
            }}
          >
            <ShareIcon />
          </IconButton>

          {/* WhatsApp Icon (next to share) */}
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              const shareUrl = window.location.href;
              const shareText = `Check out this property: ${title || "Property"}\n${shareUrl}`;
              window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(shareText)}`, "_blank");
            }}
            sx={{
              position: "absolute",
              top: 10,
              right: 55,
              background: "rgba(255,255,255,0.8)",
              "&:hover": { background: "white" },
            }}
          >
            <WhatsAppIcon sx={{ color: "#25D366" }} />
          </IconButton>
          {/* YouTube Icon (straight bottom to share icon) */}
          {youtubeLink && (
            <IconButton
              onClick={(e) => { e.stopPropagation(); window.open(youtubeLink, "_blank"); }}
              sx={{
                position: "absolute",
                bottom: 10,
                right: 10,
                background: "rgba(255,255,255,0.8)",
                "&:hover": { background: "white" },
              }}
            >
              <YouTubeIcon sx={{ color: "#FF0000" }} />
            </IconButton>
          )}
        </Box>

        {/* TITLE */}
        <Typography
          sx={{
            pt: { xs: 2, md: 2 },
            pb: 1,
            textAlign: "center",
            fontWeight: 600,
            fontSize: 17,
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {title || ""}
        </Typography>
      </Card>


      <Dialog
        open={openPreview}
        onClose={() => setOpenPreview(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: "hidden",
            bgcolor: "rgba(0,0,0,0.5)",
          },
        }}
      >
        {/* CLOSE BUTTON (TOP RIGHT) */}
        <IconButton
          onClick={() => setOpenPreview(false)}
          sx={{
            position: "absolute",
            top: { xs: 10, sm: 16 },
            right: { xs: 10, sm: 20 },
            zIndex: 10,
            color: "#fff",
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent sx={{ p: 0 }}>
          <Box
            sx={{
              position: "relative",
              height: { xs: 320, sm: 500, md: 600 },
              bgcolor: "transparent",
              overflow: "hidden"
            }}
          >
            {/* LEFT ARROW */}
            {safeImage.length > 1 && (
              <IconButton
                onClick={() => previewSliderRef.current?.slickPrev()}
                sx={{
                  position: "absolute",
                  left: 12,
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 3,
                  color: "#fff",
                  bgcolor: "rgba(0,0,0,0.5)",

                  "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
                }}
              >
                <ArrowBackIosNewIcon />
              </IconButton>
            )}
            {/* SLIDER */}
            <Slider
              ref={previewSliderRef}
              initialSlide={activeIndex}
              dots
              infinite
              speed={400}
              slidesToShow={1}
              slidesToScroll={1}
              arrows={false}
            >
              {safeImage?.map((img, i) => (
                <Box key={i}>
                  <Box
                    sx={{
                      height: { xs: 320, sm: 500, md: 600 },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      bgcolor: "rgba(0,0,0,0.5)",
                      p: 1,
                    }}
                  >
                    {isVideo(img) ? (
                      <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
                        <video
                          ref={(el) => (previewVideoRefs.current[img] = el)}
                          src={img}
                          loop
                          muted
                          playsInline
                          disablePictureInPicture
                          disableRemotePlayback
                          controlsList="nopictureinpicture"
                          onContextMenu={(e) => e.preventDefault()}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                        />
                        <IconButton
                          onClick={(e) => togglePreviewPlay(e, img)}
                          sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            bgcolor: "rgba(0,0,0,0.5)",
                            color: "white",
                            borderRadius: "4px", // Rectangular
                            "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
                          }}
                        >
                          {previewVideoRefs.current[img]?.paused ? <PlayArrowIcon /> : <PauseIcon />}
                        </IconButton>
                      </Box>
                    ) : (
                      <img
                        src={img}
                        alt=""
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain",
                        }}
                      />
                    )}
                  </Box>
                </Box>
              ))}
            </Slider>

            {/* RIGHT ARROW */}
            {safeImage.length > 1 && (
              <IconButton
                onClick={() => previewSliderRef.current?.slickNext()}
                sx={{
                  position: "absolute",
                  right: 12,
                  top: "50%",
                  transform: "translateY(-50%)",
                  zIndex: 3,
                  color: "#fff",
                  bgcolor: "rgba(0,0,0,0.5)",
                  "&:hover": { bgcolor: "rgba(0,0,0,0.7)" },
                }}
              >
                <ArrowForwardIosIcon />
              </IconButton>
            )}
          </Box>
        </DialogContent>
      </Dialog>

      {/* <Dialog
        open={openPreview}
        onClose={() => setOpenPreview(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            background: "rgba(0,0,0,0.9)",
            boxShadow: "none",
            m: 0,
            p: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
        }}
        TransitionComponent={Fade}
      >
        <Box
          sx={{
            position: "relative",
            width: "100%",
            maxWidth: 900,
            mx: "auto",
          }}
        >

          <IconButton
            onClick={() => setOpenPreview(false)}
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              color: "white",
              background: "rgba(0,0,0,0.5)",
              "&:hover": { background: "rgba(0,0,0,0.7)" },
              zIndex: 10,
            }}
          >
            <CloseIcon />
          </IconButton>


          {safeImage.length > 1 && (
            <IconButton
              onClick={prev}
              sx={{
                position: "absolute",
                left: 0,
                top: "50%",
                transform: "translateY(-50%)",
                color: "white",
                background: "rgba(0,0,0,0.3)",
                "&:hover": { background: "rgba(0,0,0,0.5)" },
              }}
            >
              <ArrowBackIosNewIcon />
            </IconButton>
          )}


          <Box
            sx={{
              width: "100%",
              height: 500,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              borderRadius: 2,
            }}
          >
            <img
              src={safeImage[index] || "/assets/images/placeholder_img.png"}
              alt="full-preview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </Box>



          {safeImage.length > 1 && (
            <IconButton
              onClick={next}
              sx={{
                position: "absolute",
                right: 0,
                top: "50%",
                transform: "translateY(-50%)",
                color: "white",
                background: "rgba(0,0,0,0.3)",
                "&:hover": { background: "rgba(0,0,0,0.5)" },
              }}
            >
              <ArrowForwardIosIcon />
            </IconButton>
          )}
        </Box>
      </Dialog> */}
    </>
  );
}